import React from 'react';
import styled from 'styled-components';
import AddExchangeButton from './AddExchangeButton';
import ExchangesGrid from '../../../components/agGrid/ExchangesGrid/ExchangesGrid';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Exchanges = () => {
  return (
    <Wrapper>
      <AddExchangeButton />
      <ExchangesGrid />
    </Wrapper>
  );
};

export default Exchanges;
